import { Button, CircularProgress, Stack } from "@mui/material";
import { switchChain } from "@wagmi/core";
import { wagmiConfig } from "config/wagmi";
import { useAccount } from "wagmi";
import { AccountButton } from "widgets/account-button";

interface Props {
  chainIdFrom: number;
  onBridge: () => void;
  isLoading?: boolean;
  isValid: boolean;
  buttonText: string;
}
export const ActionButton = ({
  chainIdFrom,
  onBridge,
  isLoading,
  isValid,
  buttonText,
}: Props) => {
  const { address: account, chainId: userChainId } = useAccount();

  const handleChangeNetwork = () =>
    switchChain(wagmiConfig, {
      chainId: chainIdFrom,
    });

  if (!account) {
    return <AccountButton />;
  }

  if (chainIdFrom === userChainId) {
    return (
      <Button
        onClick={onBridge}
        variant="contained"
        disabled={isLoading || !isValid}
        fullWidth
      >
        <Stack
          gap={2}
          direction="row"
          component="span"
          color={isLoading ? "text.primary" : undefined}
        >
          {isLoading && (
            <CircularProgress
              size="1.5rem"
              color="primary"
              sx={{
                borderRadius: "50%",
                backgroundColor: "transparent",
              }}
            />
          )}
          {buttonText}
        </Stack>
      </Button>
    );
  }

  return (
    <Button
      onClick={handleChangeNetwork}
      variant="outlined"
      color="secondary"
      fullWidth
    >
      Change Network
    </Button>
  );
};
